import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20.764}
      height={24.298}
      viewBox="0 0 20.764 24.298"
      {...props}
    >
      <path
        data-name="Path 12343"
        d="M20.764 10.38a10.382 10.382 0 10-15.639 8.96v3.36a1.63 1.63 0 001.608 1.6h7.233a1.571 1.571 0 001.538-1.6v-3.3a10.363 10.363 0 005.26-9.02zM3.976 8.649a.839.839 0 01-.78-1.149 7.757 7.757 0 014.322-4.322.839.839 0 11.624 1.557 6.08 6.08 0 00-3.388 3.388.839.839 0 01-.778.526z"
        fill="#fff"
      />
    </svg>
  )
}

export default SvgComponent
